import { useRecoilState, useRecoilValue } from 'recoil';
import { currentStateState, selectedCurrentStateActionState } from '../../../storage/client';
import { CurrentStateAction } from '../../../types/currentState';
import CommandModal from '../../commands/modal/CommandModal';
import HistoricReportModal from '../../reports/modal/HistoricReportModal';
import CurrentStateModal from './CurrentStateModal';
import DtcListModal from './DtcListModal';

function CurrentStateActionModals() {
  const [action, setAction] = useRecoilState(selectedCurrentStateActionState);
  const currentState = useRecoilValue(currentStateState(action?.ident ?? ''));

  const closeAction = () => {
    setAction(undefined);
  };

  const commandActions = [CurrentStateAction.command, CurrentStateAction.audioCommand]

  return (
    <>
      <CurrentStateModal
        onClose={closeAction}
        isOpen={action?.name === CurrentStateAction.info}
        ident={currentState?.ident}
      />
      <CommandModal
        onClose={closeAction}
        isOpen={action ? commandActions.includes(action.name) : false}
        asset={currentState?.asset}
        commandCategory={action?.name === CurrentStateAction.audioCommand ? "AUDIO" : undefined}
      />
      <HistoricReportModal
        onClose={closeAction}
        isOpen={action?.name === CurrentStateAction.historicReport}
        assetId={currentState?.asset._id}
      />
      <DtcListModal
        onClose={closeAction}
        isOpen={action?.name === CurrentStateAction.dtcList}
        assetId={currentState?.asset._id}
      />
    </>
  );
}

export default CurrentStateActionModals;
